'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'fire';
var width = 448;
var height = 512;
var aliases = [128293];
var unicode = 'f06d';
var svgPathData = 'M252.2 99.4c-11.4-14.2-32.8-35.9-52-54.6c-9.3-9-17.9-17.2-24.3-23.2c-4.3 4-9.8 9.2-16.1 15.5c-16.2 16-37.8 38.7-59.3 65.4c-21.6 26.7-42.8 57.2-58.7 88.7C25.9 223 16 254.8 16 284.5C16 403.5 107.5 496 224 496c115.2 0 208-92.5 208-211.5c0-52.7-31.2-108.6-64.8-153c-16.5-21.8-33.1-40.1-45.5-53c-4-4.2-7.6-7.7-10.6-10.7c-2.5 2.1-5.4 4.5-8.3 7c-10.7 9.1-21.2 18.8-25.5 24.4l-12.4 16.2-12.8-16zM0 284.5C0 152 176 0 176 0s49.6 45.5 78.1 77.1c4 4.4 7.6 8.6 10.6 12.3c2.6-3.3 6.5-7.5 11-11.8C290.6 63.3 312 46.6 312 46.6s136 121.4 136 237.9C448 412.2 348.2 512 224 512C98.4 512 0 412.1 0 284.5zM303.4 408.3C279.8 424 254.3 432 225.7 432c-35 0-67.4-11.3-91.3-33.1C110.3 377 96 345.3 96 306.8c0-20.5 6.5-39.1 18-58.6c11.2-19.2 27.8-40.5 48.8-66.2l12.5-15.4L187.7 182c2.9 3.6 24.7 31.3 45.7 58L262 276.4l.8 1 37.9-44 13-15.1 12 15.9c5.1 6.8 8.4 13.5 11.2 18.9l.1 .1c28.6 52.6 16.3 120.4-33.1 154.9l-.3 .2s0 0 0 0zM262.3 302.6l-10.1-12.8c-16.7-21.2-49.9-63.4-66.8-84.9c-5.4-6.8-9.1-11.5-10.2-12.9c-3.6 4.4-7 8.7-10.3 12.8c-35.3 44.1-52.9 71.3-52.9 102C112 375.4 162.6 416 225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4l-1.2-2.3c-2.4-4.8-5-9.6-8.7-14.5L302 256.3l-29.2 33.9-10.6 12.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFire = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;